import React, { useState, useRef, useEffect } from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import styles from "./styles.module.scss";

const ExpandableParagraph = ({ content, children }) => {
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const paragraph = useRef(null);
  useEffect(() => {
    setShowButton(
      paragraph.current.scrollHeight > paragraph.current.clientHeight
    );
    return () => {};
  }, [content, children]);
  return (
    <>
      <p
        className={cn({
          [styles.contracted]: !expanded,
          [styles.faded]: showButton,
        })}
        ref={paragraph}
      >
        <pre className={styles.content}>{children || content}</pre>
      </p>
      {showButton && (
        <button
          type="button"
          onClick={() => setExpanded(!expanded)}
          className={`${styles.button} btn-text`}
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      )}
    </>
  );
};

ExpandableParagraph.propTypes = {
  content: PropTypes.string,
  children: PropTypes.node,
};

ExpandableParagraph.defaultProps = {
  content: "",
  children: undefined,
};

export default ExpandableParagraph;
